import api from "../../domain/api";
import {
  GET_CLOSEDCANDIDATES_STATED,
  GET_CLOSEDCANDIDATES,
  GET_CLOSEDCANDIDATES_ENDED,
  ADD_CLOSEDCANDIDATE_STATED,
  ADD_CLOSEDCANDIDATE,
  ADD_CLOSEDCANDIDATE_ENDED,
  EDIT_CLOSEDCANDIDATE_STATED,
  EDIT_CLOSEDCANDIDATE,
  EDIT_CLOSEDCANDIDATE_ENDED,
  GET_CLOSEDCANDIDATE_STATED,
  GET_CLOSEDCANDIDATE,
  GET_CLOSEDCANDIDATE_ENDED,
  GET_ALL_CLOSEDCANDIDATES_STATED,
  GET_ALL_CLOSEDCANDIDATES,
  GET_ALL_CLOSEDCANDIDATES_ENDED,
} from "../types/closedcandidate_type";
import * as qs from "qs";
import { handleError } from "../../shared/handleError";
import { setAlert } from "./alert";

export const addClosedcandidate = (formData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ADD_CLOSEDCANDIDATE_STATED,
    });
    const { data } = await api.post(`/closedcandidates`, formData);
    dispatch({
      type: ADD_CLOSEDCANDIDATE,
      payload: data,
    });
    dispatch({
      type: ADD_CLOSEDCANDIDATE_ENDED,
    });
  } catch (error) {
    dispatch({
      type: ADD_CLOSEDCANDIDATE_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getClosedcandidates =
  ({ pageNumber = ""}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_CLOSEDCANDIDATES_STATED,
      });
      const queryParams = qs.parse(window.location.search.replace("?", ""));
      const query = qs.stringify(queryParams, {
        encodeValuesOnly: true, // prettify url
      });

      const { data } = await api.get(
        `/closedcandidates?&pageNumber=${pageNumber}&${query}`
      );

      dispatch({
        type: GET_CLOSEDCANDIDATES,
        payload: data,
      });
      dispatch({
        type: GET_CLOSEDCANDIDATES_ENDED,
      });
    } catch (error) {
      dispatch({
        type: GET_CLOSEDCANDIDATES_ENDED,
      });
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };
export const getClosedcandidate = (id) => async (dispatch) => {
  try {
    dispatch({
      type: GET_CLOSEDCANDIDATE_STATED,
    });
    const { data } = await api.get(`/closedcandidates/${id}`);

    dispatch({
      type: GET_CLOSEDCANDIDATE,
      payload: data,
    });
    dispatch({
      type: GET_CLOSEDCANDIDATE_ENDED,
    });
  } catch (error) {
    dispatch({
      type: GET_CLOSEDCANDIDATE_STATED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const editClosedcandidate = (id, formData) => async (dispatch) => {
  try {
    dispatch({
      type: EDIT_CLOSEDCANDIDATE_STATED,
    });
    const { data } = await api.put(`/closedcandidates/${id}`, formData);
    dispatch({
      type: EDIT_CLOSEDCANDIDATE,
      payload: data,
    });
    dispatch({
      type: EDIT_CLOSEDCANDIDATE_ENDED,
    });
  } catch (error) {
    dispatch({
      type: EDIT_CLOSEDCANDIDATE_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const deleteClosedcandidate = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/closedcandidates/${id}`);
    dispatch(setAlert("Closedcandidate Deleted Successfully", "success"));
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getAllClosedcandidates = ({ term, value }) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ALL_CLOSEDCANDIDATES_STATED,
    });
    const { data } = await api.get(`/closedcandidates/all?term=${term}&value=${value}`);

    dispatch({
      type: GET_ALL_CLOSEDCANDIDATES,
      payload: data,
    });
    dispatch({
      type: GET_ALL_CLOSEDCANDIDATES_ENDED,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_CLOSEDCANDIDATES_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};

export const handleErrorLocal = () => async (dispatch) => {};
